import { Check } from 'lucide-react';

interface VehicleDetailFeaturesProps {
  optionals: string[];
}

export function VehicleDetailFeatures({ optionals }: VehicleDetailFeaturesProps) {
  if (!optionals?.length) return null;

  return (
    <section className="wl7-vd-section">
      <div className="wl7-vd-section__head">
        <p className="wl7-eyebrow">Equipamentos</p>
        <h2 className="wl7-vd-section__title wl7-h2">Opcionais ({optionals.length})</h2>
      </div>

      <div className="wl7-vd-features">
        {optionals.map((optional, index) => (
          <div key={index} className="wl7-vd-feature">
            <Check className="wl7-vd-feature__check" aria-hidden />
            <span>{optional}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
